export default __webpack_public_path__ + "static/media/DE-Logo.f3778000.png";